import { InfoOutlineIcon, LockIcon } from "@chakra-ui/icons";
import {
  Box,
  Card,
  CardBody,
  Divider,
  Flex,
  HStack,
  Icon,
  Text,
  Tooltip,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { TrendingDown, TrendingUp } from "react-feather";
import { customCurrencyFormat, getPixelCount } from "../../../utils";

const InfoTooltip = ({ detailInfo }) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Tooltip
      label={detailInfo}
      placement="top"
      hasArrow
      whiteSpace="normal"
      color="#2D3748"
      bg="#FFFFFF"
      isOpen={isMobile ? isOpen : undefined} // Controlled on mobile, default hover on desktop
      openDelay={300}
      closeOnClick
      modifiers={[
        {
          name: "preventOverflow",
          options: { boundary: "viewport", padding: 8 },
        },
        { name: "flip", enabled: false },
        { name: "computeStyles", options: { adaptive: false } },
      ]}
    >
      <Box
        backgroundColor="#FFFFFF"
        borderRadius="8px"
        p="4px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        onClick={isMobile ? () => (isOpen ? onClose() : onOpen()) : undefined}
      >
        <Icon as={InfoOutlineIcon} color="#2D3748" boxSize={4} />
      </Box>
    </Tooltip>
  );
};

export default InfoTooltip;

export const AdvancedMetricsLowerCard = ({
  top = "-",
  left = "-",
  right = "-",
  topTitle = "",
  leftTitle = "",
  rightTitle = "",
  percentageColor,
  detailInfo = "",
  symbol,
  isLocked = false,
}) => {
  return (
    <Card
      bg={"white"}
      borderRadius="8px"
      boxShadow="sm"
      height="168px"
      w="100%"
    >
      <CardBody
        p={"16px"}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="stretch"
        h="100%"
        minH={0}
        gap={2}
      >
        <Flex justify="center" align="center" w="100%">
          <HStack spacing="3px" align="center">
            <Text fontSize="17px" fontWeight="700" textAlign="center">
              {topTitle}
            </Text>
            <InfoTooltip detailInfo={detailInfo}></InfoTooltip>
          </HStack>
        </Flex>

        <Flex justify="center" align="center">
          <Text
            fontSize={getPixelCount(
              { base: "25px", md: "28px", lg: "30px" },
              customCurrencyFormat(top, false, false, true, false),
              8,
              1
            )}
            fontWeight="600"
            lineHeight="1"
          >
            {customCurrencyFormat(top, false, false, true, false)}
          </Text>
        </Flex>

        <Divider />

        <Flex align="stretch" justify="space-between">
          <Box textAlign="center" flex="1" minW={0}>
            <Text fontSize="13px" color="gray.600">
              {leftTitle}
            </Text>
            <Text
              fontWeight="bold"
              fontSize={getPixelCount(
                "20px",
                customCurrencyFormat(
                  left,
                  false,
                  false,
                  true,
                  false,
                  false,
                  true
                ),
                8,
                1
              )}
              lineHeight="1.1"
              noOfLines={1}
            >
              {customCurrencyFormat(
                left,
                false,
                false,
                true,
                false,
                false,
                true
              )}
            </Text>
          </Box>

          <Box mx={3} w="1px" bg={"gray.200"} alignSelf="stretch" />

          <Flex
            textAlign="center"
            flex="1"
            minW={0}
            direction="column"
            align="center"
            justify="center"
          >
            <Text fontSize="13px" color="gray.600">
              {rightTitle}
            </Text>
            <HStack spacing={1} justify="center" align="center">
              {symbol ? (
                <TrendingUp size={20} color={percentageColor} />
              ) : (
                <TrendingDown size={20} color={percentageColor} />
              )}
              <Text
                fontWeight="bold"
                color={percentageColor}
                fontSize={getPixelCount(
                  "20px",
                  customCurrencyFormat(
                    right,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true
                  ),
                  8,
                  2
                )}
                lineHeight="1.1"
                noOfLines={1}
              >
                {customCurrencyFormat(
                  right,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true
                )}
              </Text>
            </HStack>
          </Flex>
        </Flex>
        {isLocked && (
          <Box
            position="absolute"
            top={0}
            left={0}
            w="100%"
            h="100%"
            bg="rgba(255, 255, 255, 0.7)"
            backdropFilter="blur(5px)"
            zIndex={10}
            display="flex"
            flexDir={"column"}
            alignItems="center"
            justifyContent="center"
          >
            <LockIcon></LockIcon>
            <Text
              fontWeight={700}
              fontSize="lg"
              color="gray.700"
              p={2}
              textAlign={"center"}
            >
              Upgrade to Unlock {topTitle}
            </Text>
          </Box>
        )}
      </CardBody>
    </Card>
  );
};
